<template>
    <form v-on:submit.prevent="editOrder">
      <div class="modal-card" v-if="isAdmin">
        <header class="modal-card-head" style="background:#222">
            <p class="modal-card-title" style="color:white"><span style="color: #7cda24">Edit</span> {{order.type}}</p>
        </header>
        <section class="modal-card-body">
          <b-field label="Delivery Address">
            <b-input type="textarea" v-model="order.delivery.address"></b-input>
          </b-field>

          <b-field label="Transaction Reference">
            <b-input
              type="text"
              v-model="order.transaction_reference"
              placeholder="e.g. MP.080000.00000">
            </b-input>
          </b-field>

          <b-field label="Delivery Date">
            <b-datepicker
              placeholder="Type or select a date..."
              icon="calendar-today"
              editable
              v-model="deliveryDate">
            </b-datepicker>
          </b-field>

          <b-field label="Customer Name">
            <b-input
              type="text"
              v-model="order.delivery.name"
              placeholder="e.g. Jane Doe"
              required>
            </b-input>
          </b-field>

          <b-field label="Customer Mobile Number">
            <b-input
              type="text"
              v-model="order.delivery.mobile_number"
              placeholder="e.g. 07XXXXXXXX"
              required>
            </b-input>
          </b-field>

          <b-field label="Order Note">
            <b-input type="textarea" v-model="order.note"></b-input>
          </b-field>

          <b-field label="Order Instructions">
            <b-input type="textarea" v-model="order.delivery.notes"></b-input>
          </b-field>

        </section>
        <footer class="modal-card-foot">
            <button class="button is-primary is-outlined" type="submit">Save Changes</button>
            <button class="button is-dark" type="button" @click="$parent.close">Close</button>
        </footer>
      </div>
    </form>
</template>

<script>
import { ucFirst, currencies, ls } from '@/helpers';
import { mapGetters } from 'vuex';
import decode from 'jwt-decode'

export default {
    name: "EditProductModal",
    data() {
        return {
          currencies,
          deliveryDate: new Date(this.order.delivery.date)
        }
    },
    props: ['order'],
    computed: {
      userAuth() {
        return ls('token') ? decode(ls('token')) : null;
      },
      isAdmin() {
        return this.userAuth ? this.userAuth.type === "admin" : false;
      }
    },
    created() {
      this.deliveryDate.setHours(0,0,0,0);
    },
    methods: {
      editOrder() {
        const loading = this.$loading.open();
        this.order.delivery.date = this.deliveryDate.getTime();
        this.$store.dispatch('editOrder', this.order).then(() => {
          loading.close();
          this.$parent.close();
          this.$toasted.global.success(`Order Edited!`);
          this.$emit('reload')
        }).catch(e=> {
          loading.close();
          console.log('Exception when editing order',e);
          this.$toasted.global.error('Failed to save changes. Please try again.');
        })
      }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/SoilTests/EditOrderModal.vue